import { Decodable } from './_decodable';
import { Accompaniment } from './accompaniment';
import { Board } from './board';
import { Client } from './client';
import { Contract } from './contract';
import { Cycle } from './cycle';
import { Director } from './director';

class AnaliseCriticaLog extends Decodable {

    id: number
    action: number
    director: Director
    board: Board
    directorName: string
    observation: string

    updatedAt: Date
    createdAt: Date

    actions = {
        'opened': 1,
        'approved': 2,
        'reproved': 3,
        'sent_automatically': 4,
        'sent_manually': 5,
        'finalize': 6,
        'restarted': 7,
        'created': 8,
        'updated': 9,
        'deleted': 10,
    };

    actionsMapping = {
        [this.actions.opened]: 'abriu o link da análise crítica',
        [this.actions.approved]: 'aprovou a análise crítica',
        [this.actions.reproved]: 'reprovou a análise crítica',
        [this.actions.sent_automatically]: 'recebeu o link da análise crítica a partir do envio automático',
        [this.actions.sent_manually]: 'recebeu o link da análise crítica a partir do envio manual',
        [this.actions.finalize]: 'encerrou o processo da análise crítica automaticamente',
        [this.actions.restarted]: 'reiniciou o processo da análise crítica',
        [this.actions.created]: 'criou a análise crítica',
        [this.actions.updated]: 'atualizou a análise crítica',
        [this.actions.deleted]: 'excluiu a análise crítica',
    };

    get actionName(): string {
        if(this.action === this.actions.approved) {
            return 'Aprovada'
        } else if(this.action === this.actions.reproved) {
            return 'Reprovada'
        }
        
        return 'Pendente'
        
    }

    get statusColor(): string {
        if(this.action === this.actions.approved) {
            return '#10B981'; // emerald
        } else if(this.action === this.actions.reproved) {
            return '#EF4444'; // soft red
        }
        
        return '#F59E0B'; // amber
        
    }

     getActionClass(action: number): string {
        if (action === this.actions.opened || action === this.actions.sent_automatically || action === this.actions.sent_manually || action === this.actions.finalize) {
            return 'action-blue';
        } else if (action === this.actions.approved) {
            return 'action-green';
        } else if (action === this.actions.reproved) {
            return 'action-red';
        } else if (action === this.actions.restarted) {
            return 'action-yellow';
        } else if (action === this.actions.created) {
            return 'action-green';
        } else if (action === this.actions.updated) {
            return 'action-blue';
        } else if (action === this.actions.deleted) {
            return 'action-red';
        }

        return '';
    }

    getActionIcon(action: number): string {
        if (action === this.actions.opened || action === this.actions.sent_automatically || action === this.actions.sent_manually || action === this.actions.finalize) {
            return 'star';
        } else if (action === this.actions.approved) {
            return 'check_circle';
        } else if (action === this.actions.reproved) {
            return 'cancel';
        } else if (action === this.actions.restarted) {
            return 'history';
        } else if (action === this.actions.created) {
            return 'add';
        } else if (action === this.actions.updated) {
            return 'edit';
        } else if (action === this.actions.deleted) {
            return 'delete';
        }

        return '';
    }


    protected _map = {
        updatedAt: e => this.parseDate(e),
        createdAt: e => this.parseDate(e),
        director: e => Director.parse(e),
        board: e => Board.parse(e),
    }
}

export {
    AnaliseCriticaLog
}